import { ReactNode } from 'react';
import {
  ActivityFeed,
  ActivityFeedChange,
} from 'src/graphql/entities/activity-feed/hooks/use-activity-feed';
import { SUPPRESS_ACTIVITY_ROW } from './suppress-activity-row';

export function getCustomClientFieldMessage(
  change: ActivityFeedChange,
  activity: ActivityFeed,
): ReactNode | typeof SUPPRESS_ACTIVITY_ROW {
  const actorName = activity.actor?.name?.trim() || '<Platform User>';

  switch (change.field) {
    case 'deletedAt': {
      const isRestored = change.previousValue !== null && change.value === null;
      if (isRestored) {
        return `${actorName} restored the client`;
      }
      // A soft delete has its own `delete` activity, so the raw timestamp must not render here.
      return SUPPRESS_ACTIVITY_ROW;
    }
    default:
      return null;
  }
}
